export const authSessionStartAtSelector = state => state.googleAnalytics.authSessionStartAt;

export const dataAnalysisPermission = state => state.googleAnalytics.permissionGiven;
